import React from 'react';

const errorBoxStyle = {
  border: '1px solid #dc3545',
  borderRadius: '8px',
  padding: '16px',
  marginBottom: '20px',
  backgroundColor: '#fff5f5',
  color: '#c53030',
  boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
};

const errorItemStyle = {
  marginBottom: '12px',
  paddingBottom: '12px',
  borderBottom: '1px solid #feb2b2',
};

const labelStyle = {
  fontWeight: 'bold',
  marginRight: '8px',
  color: '#742a2a'
};

const codeStyle = {
  fontFamily: 'monospace',
  backgroundColor: '#f7fafc',
  padding: '2px 6px',
  borderRadius: '4px',
  border: '1px solid #e2e8f0',
  color: '#2d3748',
  fontSize: '0.9em',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-all'
}

const ErrorDisplay = ({ errors }) => {
  if (!errors || (Array.isArray(errors) && errors.length === 0)) {
    return null;
  }

  const errorList = Array.isArray(errors) ? errors : [errors];

  return (
    <div style={errorBoxStyle}>
      <h4 style={{ marginTop: 0, marginBottom: '16px', fontSize: '1.1em' }}>アップロードエラー</h4>
      {errorList.map((error, index) => (
        <div key={index} style={{ ...errorItemStyle, borderBottom: index === errorList.length - 1 ? 'none' : errorItemStyle.borderBottom }}>
          {error.row && (
            <div style={{ marginBottom: '4px' }}>
              <span style={labelStyle}>対象行:</span>
              <span>{error.row}行目</span>
            </div>
          )}
          <div style={{ marginBottom: '4px' }}>
            <span style={labelStyle}>エラーコード:</span>
            <span style={codeStyle}>{error.code || error.error_code || 'BS900'}</span>
          </div>
          <div style={{ marginBottom: '4px' }}>
             <p style={{ margin: '4px 0', fontWeight: '500' }}>{error.message || '不明なエラーが発生しました。'}</p>
          </div>
          {error.originalError && (
            <div style={{ marginTop: '8px', fontSize: '0.85em', color: '#4a5568' }}>
              <span style={labelStyle}>詳細:</span>
              <code style={codeStyle}>{error.originalError}</code>
            </div>
          )}
          {error.stack && (
            <div style={{ marginTop: '8px', fontSize: '0.85em', color: '#4a5568' }}>
              <span style={labelStyle}>スタックトレース:</span>
              <code style={codeStyle}>{error.stack}</code>
            </div>
          )}
          {error.raw_error && (
            <div style={{ marginTop: '8px', fontSize: '0.85em', color: '#4a5568' }}>
              <span style={labelStyle}>Stripe詳細:</span>
              <code style={codeStyle}>{error.raw_error}</code>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default ErrorDisplay;
